import { FC } from 'react';
import MyHomeLockupSvg from './my-home-lockup.svg';

type MyHomeLockupProps = Omit<JSX.IntrinsicElements['img'], 'src'> & {
    alt?: string;
};

const MyHomeLockup: FC<MyHomeLockupProps> = ({
    alt = 'My Home',
    width = 122,
    ...props
}) => {
    return <img src={MyHomeLockupSvg} alt={alt} width={width} {...props} />;
};

export default MyHomeLockup;
